<template>
  <v-tooltip v-model="showTooltip" bottom>
    <template v-slot:activator="{ attrs }">
      <v-btn icon x-small class="copy-btn ml-1" v-bind="attrs" @mouseenter="showTooltip = true" @mouseleave="onMouseLeave" @click.stop="copy">
        <v-icon small :color="copied ? 'success' : 'grey'">
          {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ copied ? 'Copied!' : 'Copy' }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'CopyBtn',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    copied: false,
    showTooltip: false
  }),
  methods: {
    onMouseLeave() {
      if (!this.copied) {
        this.showTooltip = false
      }
    },
    copy() {
      navigator.clipboard.writeText(this.value)
      this.copied = true
      this.showTooltip = true
      setTimeout(() => {
        this.copied = false
        this.showTooltip = false
      }, 1500)
    }
  }
}
</script>

<style scoped>
.copy-btn {
  vertical-align: middle;
}
</style>
